import React, { useState } from 'react';
import styled from 'styled-components';

import { Stack, Text, TextLink } from '@origin-digital/ods-core';
import { TileButtonGroup, TileButton } from '@origin-digital/ods-tile-button';
import { ConnectionAddressObject } from '@origin-digital/address-lookup';

import { useNMIResolution } from './useNMIResolution';

export interface IAddressListing {
  id: string;
  addresses: ConnectionAddressObject[];
  isError?: boolean;
  onChange: (event: React.MouseEvent<HTMLElement>, value: any) => void;
  selectedAddress?: string;
}

export const DEFAULT_SHOW_ADDRESS_THRESHOLD = 3;
export const MAXIMUM_SHOW_ADDRESS_THRESHOLD = 6;

export const ConfirmAddressListing: React.FC<IAddressListing> = ({
  id,
  addresses,
  isError,
  onChange,
  selectedAddress,
}) => {
  const [showMore, setShowMore] = useState<boolean>(false);

  const { maskNMILabel } = useNMIResolution();

  return (
    <Stack space="small">
      <ErrorWrapper isError={isError}>
        <TileButtonGroup
          id={id}
          data-id={id}
          togglePosition="left"
          onChange={onChange}
          defaultValue={selectedAddress as string}
          hideHelperTextSpace
        >
          {addresses
            .slice(0, showMore ? MAXIMUM_SHOW_ADDRESS_THRESHOLD : DEFAULT_SHOW_ADDRESS_THRESHOLD)
            .map((address) => (
              <TileButton
                aria-label={address.addressLabel}
                key={address.nmi}
                id={address.nmi as string}
                label={address.addressLabel}
                value={address.nmi as string}
                selected={address.nmi === selectedAddress}
                helperText={maskNMILabel(address.nmi)}
              />
            ))}
        </TileButtonGroup>
      </ErrorWrapper>
      {addresses.length > DEFAULT_SHOW_ADDRESS_THRESHOLD && !showMore && (
        <Text>
          <TextLink
            href=""
            onClick={(event) => {
              event.preventDefault();
              setShowMore(true);
            }}
          >
            Show more
          </TextLink>
        </Text>
      )}
    </Stack>
  );
};

const ErrorWrapper = styled.div<{ isError?: boolean }>`
  button.MuiToggleButtonGroup-grouped,
  button.MuiToggleButtonGroup-grouped:not(:first-child) {
    ${({ isError }) => (isError ? 'border: 1px solid #ec0000' : '')};
  }
`;
